import React from 'react';
import { arrayOf, bool, number, shape } from 'prop-types';
import ProgressBar from '../components/ProgressBar';

import defaultClasses from './RuleSummaryTiles.module.css';

const formatter = new Intl.NumberFormat();

const RuleSummaryTiles = ({isLoading, kpis, rules}) => {
    let count;
    let activeFaults;
    let ruleFailures;
    if (isLoading) {
        count = '--';
        activeFaults = '--';
        ruleFailures = '--';
    } else {
        if (process.env.ruleBuilderUpdatedMetricsEnabled) {
            count = formatter.format(kpis.totalCount || 0);
            activeFaults = formatter.format(kpis.activeFaults || 0);
            ruleFailures = formatter.format(kpis.failureCounts || 0);
        } else {
            count = formatter.format(rules.length);
            const result = rules.reduce((result, rule) => {
                result.activeFaults += (rule.activeFaults || 0);
                result.ruleFailures += (rule.failureCounts || 0);
                return result;
            }, {activeFaults: 0, ruleFailures: 0});
            activeFaults = result.activeFaults;
            ruleFailures = result.ruleFailures;
        }

    }
    return (
        <>
            <ProgressBar
                hidden={!isLoading}
            />
            <ul className={defaultClasses.root}>
                <li className={defaultClasses.tile}>
                    <header className={defaultClasses.header}>
                        Enabled Rules
                    </header>
                    <span className={defaultClasses.value}>
                        {count}
                    </span>
                </li>
                <li className={defaultClasses.tile}>
                    <header className={defaultClasses.header}>
                        Active Faults
                    </header>
                    <span className={defaultClasses.value}>
                        {activeFaults}
                    </span>
                </li>
                <li className={defaultClasses.tile}>
                    <header className={defaultClasses.header}>
                        Rule Failures
                    </header>
                    <span className={defaultClasses.value}>
                        {ruleFailures}
                    </span>
                </li>
            </ul>
        </>
    );
};

if (process.env.ruleBuilderUpdatedMetricsEnabled) {
    RuleSummaryTiles.defaultProps = {
        isLoading: false,
        kpis:      {}
    };

    RuleSummaryTiles.propTypes = {
        isLoading: bool,
        kpis:      shape({
            activeFaults:    number,
            executionFaults: number,
            failureCounts:   number,
            totalCount:      number
        })
    };
} else {
    RuleSummaryTiles.defaultProps = {
        isLoading: false,
        rules:     []
    };

    RuleSummaryTiles.propTypes = {
        isLoading: bool,
        rules:     arrayOf(shape({
            activeFaults:  number,
            failureCounts: number
        }))
    };
}



export default RuleSummaryTiles;
